import Vue from 'vue'
import Vuex from 'vuex'
import { userLogin,userRegister,tempLogin } from '@/api/index'
import { getInfo } from '@/api/user'
import { getToken, setToken, removeToken, getLang } from '@/utils/auth'

Vue.use(Vuex)

/**
 * email: null
invitation_code: "00Z2"
phone: "14785564430"
token: "e27e302f8b2e908bf921eca001be9105b1460dc2"
transaction_password
id_card
bank_name
bank_number
alipay_account
weixin_nickname
weixin_account

 */

const store = new Vuex.Store({
  state: {
    __data: null,
    lang: getLang(),
    token: getToken(),
    name: null,
    invitation_code: null,
    email: null,
    phone: null,
    transaction_password: 0,
    bank_name: null,
    bank_number: null,
    alipay_account: null,
    weixin_nickname: null,
    weixin_account: null,
    usdt: '',

    isLoad: false, //加载动画
    bank: '',
    area_code: '',
    newCont: {},
    bankInfo: {},
    usdtInfo: {},
    btcInfo: {},
    wsData: null
  },
  mutations: {
    SET_DATA: (state, data) => {
      state.__data = data
    },
    SET_TP: (state, tp) => {
      state.transaction_password = tp
    },
    SET_LOGIN: (state, data) => {
      for (var key in data) {
        state[key] = data[key]
      }
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },

    bankSelect(state, payload) {
        state.bank = payload.bank
    },
    codeSelect(state, payload) {
        state.area_code = payload.area_code
    },
    newSelect(state, payload) {
        state.newCont = payload.newCont
    },
    bankInfo(state, payload) {
        state.bankInfo = payload.bankInfo
    },
    usdtInfo(state, payload) {
        state.usdtInfo = payload.usdtInfo
    },
    btcInfo(state, payload) {
        state.btcInfo = payload.btcInfo
    },
    load(state, load) {
        state.isLoad = load.isLoad
    },
    setWsData: (state, data) => {
      // console.log('vuex：',state,data)
      state.wsData = data;
    }
  },
  actions: {
    updateData({ commit }, data) {
      commit("setWsData", data);
    },
    updateData({ commit }, data) {
      commit('SET_DATA', data)
    },
    updateTP({ commit }, tp) {
      commit('SET_TP', tp)
    },
    updateInfo({ commit }, data) {
      commit('SET_LOGIN', data)
    },
    // 用户注册
    register({ commit }, data) {
      return new Promise((resolve, reject) => {
        // setToken("dfjsdfj1234sdhfsjkdhkj")
        // console.log("888888")
        // console.log(getToken())
        // commit('SET_LOGIN', {phone:"12312312",token:"dfjsdfj1234"})
        // resolve({phone:"12312312",token:"dfjsdfj1234",token_h5:"dfjsdfj1234"})
        userRegister(data).then(res => {
          setToken(res.token_h5)
          res.token = res.token_h5
          commit('SET_LOGIN', res)
          resolve(res)
        }).catch(() => {
          reject()
        })
      })
    },
    // 用户登录保存信息
    login({ commit }, data) {
      return new Promise((resolve, reject) => {
        userLogin(data).then(res => {
          setToken(res.token)
          commit('SET_LOGIN', res)
          resolve(res)
        }).catch(() => {
          reject()
        })
      })
    },
    // 用户模拟登录保存信息
    login2({ commit }, data) {
      return new Promise((resolve, reject) => {
        tempLogin(data).then(res => {
          setToken(res.token)
          commit('SET_LOGIN', res)
          resolve(res)
        }).catch(() => {
          reject()
        })
      })
    },
    // 获取用户信息
    getInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          commit('SET_LOGIN', res)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        removeToken()
        localStorage.removeItem('token');
        commit('SET_TOKEN', null)
        resolve()
      })
    }
    // 前端 登出
    // FedLogOut({ commit }) {
    //   return new Promise(resolve => {
    //     removeToken()
    //     commit('SET_TOKEN', null)
    //     resolve()
    //   })
    // }
  },
  getters: {
    token: state => state.token,
    usdt: state => state.usdt,
    phone: state => {
      var p = state.phone || state.email
      if(!p)return ''
      return p.length < 12 ? p : p.substr(0,12)
    }
  }
})

export default store




// WEBPACK FOOTER //
// ./src/store/index.js